import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import CreativeMenu from 'profile/components/creative_menu';
import mapProfileToProps from 'profile/containers/map_profile_to_props';

const mapStateToProps = (state, { params }) => {
  const profile = mapProfileToProps(state);
  const isOwner = params.profileUsername === state.user.profile_data.username;

  return {
    show: profile && profile.is_creative && !isOwner,
    profile
  };
}

export default withRouter(connect(mapStateToProps)(CreativeMenu));
